// istanbul ignore file
import { FetchCustomersData, customersDataSchema } from './customersData';
import { FetchProductListData, productListDataSchema } from './productListData';

export interface ApiClient {
  fetchCustomersData: FetchCustomersData;
  fetchProductListData: FetchProductListData;
}

// FIXME: migrate to unicorn fetchClient (should remove the need for manually sending external id header)
export const createApiClient = ({ httpClient, baseClientUrl }: { httpClient: typeof window.fetch; baseClientUrl: string }): ApiClient => {
  return {
    fetchCustomersData: (customerExternalId: string) =>
      httpClient(`${baseClientUrl}/customers`, {
        credentials: 'include',
        headers: {
          'X-Cld-Customer-External-Id': customerExternalId,
        },
      })
        .then((response) => response.json())
        .then((data: unknown) => customersDataSchema.parseAsync(data)),
    fetchProductListData: (customerExternalId) =>
      httpClient(`${baseClientUrl}/customers/product_list`, {
        credentials: 'include',
        headers: {
          'X-Cld-Customer-External-Id': customerExternalId,
        },
      })
        .then((response) => response.json())
        .then((data: unknown) => productListDataSchema.parseAsync(data)),
  };
};
